'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var reactActioncableProvider = require('react-actioncable-provider');

var useInitChatops = require('./useInitChatops-0171a88c.js');

var Chatops = require('@thewebops/chatops-web');

require('axios');

require('@rails/actioncable');

require('immer');

require('normalizr');

require('use-immer');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Chatops__default = /*#__PURE__*/_interopDefaultLegacy(Chatops);

var Wrapper = function Wrapper(_a) {
  var chatopsOptions = _a.chatopsOptions,
      isObserver = _a.isObserver,
      dataFilters = _a.dataFilters;

  var _b = useInitChatops.useChatopsOnActioncable(),
      _c = _b.state,
      users = _c.users,
      currentUser = _c.currentUser,
      currentContact = _c.currentContact,
      loading = _c.loading,
      messages = _c.messages,
      conversations = _c.conversations,
      selectedConversation = _c.selectedConversation,
      broadcastUsers = _c.broadcastUsers,
      messageDelivery = _c.messageDelivery,
      _d = _b.callbacks,
      onConversationClick = _d.onConversationClick,
      onConversationSearch = _d.onConversationSearch,
      onConversationsPagination = _d.onConversationsPagination,
      onMessagesPagination = _d.onMessagesPagination,
      onMessageSend = _d.onMessageSend,
      onTypingChange = _d.onTypingChange,
      onFetchContacts = _d.onFetchContacts,
      onFetchContact = _d.onFetchContact,
      resetContact = _d.resetContact,
      broadcast = _d.broadcast,
      _e = _b.checks,
      hasMoreConversations = _e.hasMoreConversations,
      hasMoreMessages = _e.hasMoreMessages;

  return React__default['default'].createElement(Chatops__default['default'], useInitChatops.__assign({
    footer: true,
    currentUser: currentUser,
    currentContact: currentContact,
    resetContact: resetContact,
    users: users,
    selectedConversation: selectedConversation,
    conversations: conversations,
    messages: messages,
    broadcastUsers: broadcastUsers,
    loading: loading,
    conversationExtraComponent: useInitChatops.ConversationChannel,
    hasMoreConversations: hasMoreConversations,
    hasMoreMessages: hasMoreMessages,
    onTypingChange: onTypingChange,
    onConversationClick: onConversationClick,
    onMessagesPagination: onMessagesPagination,
    onConversationsPagination: onConversationsPagination,
    onMessageSend: onMessageSend,
    onConversationSearch: onConversationSearch,
    onFetchContacts: onFetchContacts,
    onFetchContact: onFetchContact,
    broadcast: broadcast,
    isObserver: isObserver,
    messageDelivery: messageDelivery,
    dataFilters: dataFilters
  }, chatopsOptions));
};

var ChatopsOnActioncable = React__default['default'].forwardRef(function (_a, ref) {
  var user = _a.user,
      cableURL = _a.cableURL,
      apiBaseURL = _a.apiBaseURL,
      authHeaders = _a.authHeaders,
      chatopsOptions = _a.chatopsOptions,
      onGeneralCableEvent = _a.onGeneralCableEvent,
      _b = _a.isGeneralCableEnabled,
      _c = _a.isObserver,
      isObserver = _c === void 0 ? false : _c,
      _d = _a.selectFirstConversation,
      selectFirstConversation = _d === void 0 ? false : _d,
      dataFilters = _a.dataFilters,
      filterValues = _a.filterValues;
  var context = useInitChatops.useInitChatops({
    user: user,
    cableURL: cableURL,
    apiBaseURL: apiBaseURL,
    authHeaders: authHeaders,
    isObserver: isObserver,
    selectFirstConversation: selectFirstConversation,
    filterValues: filterValues
  });
  React.useImperativeHandle(ref, function () {
    return {
      cable: context.state.consumer
    };
  }, []);
  return React__default['default'].createElement(useInitChatops.ChatContext.Provider, {
    value: context
  }, React__default['default'].createElement(reactActioncableProvider.ActionCableProvider, {
    cable: context.state.consumer
  }, React__default['default'].createElement(Wrapper, {
    chatopsOptions: chatopsOptions,
    isObserver: isObserver,
    dataFilters: dataFilters
  })));
});
exports.chatConfigs = useInitChatops.chatConfigs;
exports.default = ChatopsOnActioncable;